import { MdDialogRef } from '@angular/material';
import { ApplicationValue } from './../../../services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { EntityIdDetails } from './../../../shared/models/entity-id-details.model';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EntityDetailsService } from './../../../entities/details/entity-details.service';
import { SidebarTasksService } from 'app/services/sidebar-tasks.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from './../../../shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { TaskService } from 'app/task/task.service';
import { Component, OnInit } from '@angular/core';
import { ConstantsService } from 'app/services/constants-service';
import { MessageService } from 'app/services/messages.service';

@Component({
    selector: 'app-cancel-workflow-dialog',
    templateUrl: 'cancel-workflow-dialog.component.html',
    styleUrls: ['cancel-workflow-dialog.component.css']
})
export class CancelWorkflowDialogComponent implements OnInit {
    entityId: number;
    activeWorkflow: any;
    message: String;
    entityIdDetails: EntityIdDetails;
    isClient: boolean;
    clientStateTypes: ApplicationValue;
    clientCurrentStateStatus: number;
    private cancelWorkFlowForm: FormGroup;
    constructor(
        private taskService: TaskService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
        private sidebarTasksService: SidebarTasksService,
        private entityDetailsService: EntityDetailsService,
        private warmUpService: WarmUpService,
        private formBuilder: FormBuilder,
        public dialogRef: MdDialogRef<any>,
    ) { }

    cancelWorkFlow({ value, valid }) {
        this.dialogRef.close();
        if (this.isClient) {
            this.updateClientStateStatus(value.clientState);
        }
        this.taskService.cancelWorkflow(this.entityId, this.activeWorkflow.id, value.message).
            subscribe(
            success => {
                this.taskService.sendMessage('updateActiveWorkFlow');
                this.sidebarTasksService.loadTasks();
                this.taskService.sendMessage('closeActiveWorkFlowDialog');
                this.callSnackBarService(success);
                this.trackingService
                    .emitEvent(TrackingConstants.ACTIVE_WORKFLOW, TrackingConstants.PERFORM_CANCEL_WORKFLOW, TrackingConstants.SUCCESS, 1);
            },
            err => {
                this.callSnackBarService(err);
                this.trackingService
                    .emitEvent(TrackingConstants.ACTIVE_WORKFLOW, TrackingConstants.PERFORM_CANCEL_WORKFLOW, TrackingConstants.FAILURE, 0);
            }
            );
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.CANCEL_WORKFLOW_SUCCESS,
            MessageService.CANCEL_WORKFLOW_FAILURE);
    }

    ngOnInit() {

        this.cancelWorkFlowForm = this.formBuilder.group({
            message: [''],
            clientState: [''],

        });

        this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
        this.isClient = this.entityIdDetails.isClient;
        if (this.isClient) {
            this.getClientStateStatus();
        }
    }

    getClientStateStatus() {
        this.taskService.getClientStateStatus(this.entityIdDetails.clientId).subscribe(
            success => {
                const setClientStateTypes = (values) => {
                this.clientStateTypes = values;
                    this.cancelWorkFlowForm.patchValue({
                        clientState: this.clientCurrentStateStatus
                    });
                };
                this.clientCurrentStateStatus = success.arrResult;
                this.warmUpService.getApplicationValueList(ApplicationTypeConstants.CLIENT_STATE_TYPE, setClientStateTypes);
            },
            err => {

            }
        );
    }
    updateClientStateStatus(status) {
        this.taskService.updateClientStateStatus(this.entityIdDetails.clientId, status).subscribe(
            success => {},
            err => {}
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/task/taskstructure/cancel-workflow-dialog/cancel-workflow-dialog.component.ts